<template>
    <div class="paper">
        <headers :title='title'></headers>
        <template v-if="loading">
            <template v-if="list.length">
                <div class="list"
                     v-for="l in list">
                    <h3>{{l.ch_Name}}</h3>
                    <ul v-if="l.question_data.length">
                        <li v-for="data in l.question_data">
                            <span class="recom"><span>{{data.title}}</span>({{data.question_num}}题)</span>
                            <a href="javascript:;"
                               class="preview"
                               @click="toPreview(data)">预览</a>
                            <div class="right">
                                <a href="javascript:;"
                                   :class="data.active?'add':'remove'"
                                   @click="addORRemove(data)">{{addOrRemoveText[data.active]}}</a>
                            </div>
                        </li>
                    </ul>
                    <div class="norecommend"
                         v-else>暂无推荐试卷</div>
                </div>
                <div class="self">
                    <span>以上没有合适的? 自己选题</span>
                    <span @click='optional'
                          class="optional">自选<i></i></span>
                </div>
                <div class="bottom_btn">
                    <a class="btn_a"
                       v-if='num'
                       @click='allpreview'>已选{{num}}题，点击预览</a>
                    <a v-else>已选0题，点击预览</a>
                </div>
            </template>
            <template v-else>
                <noResouse></noResouse>
            </template>
        </template>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue';
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';

export default {
    data () {
        return {
            title: '',
            sid: this.$route.params.sid,
            type: this.$route.params.type,  //0同步习题 1单元复习
            cid: JSON.parse(localStorage.getItem('ch_cid')),
            loading: false,
            list: [],
            num: 0,//选择的数量
            addOrRemoveText: ['移除', '加入'],

        }
    },
    components: {
        headers, loadingS, noResouse
    },
    methods: {

        addORRemove (paper) {
            if (paper.active) {
                paper.active = 0;
                this.num += paper.question_num;
            } else {
                paper.active = 1;
                this.num -= paper.question_num;
            }
            this.list.splice(0, 1, this.list[0])
        },
        optional () {
            let paper_id = [];
            if (this.type == 1) {
                paper_id = this.cid;
            } else {
                this.list.forEach(item => {
                    paper_id.push(item.ch_id);
                });
            }
            localStorage.setItem('paperIds', paper_id.join(','));
            this.$router.push('/chinese/select_task/select_test/' + this.sid + '/' + this.type + '?tarType=0');
        },
        toPreview (data) {
            this.$router.push('/chinese/select_task/preview/' + data.paper_id + '?title=' + data.title);
        },
        allpreview () {
            let paper_id = [];
            this.list.forEach(item => {
                item.question_data.forEach(v => {
                    if (!v.active) {
                        paper_id.push(v.paper_id)
                    }
                })
            });
            //console.log(paper_id)
            return
            localStorage.setItem('paperIds', paper_id.join(','));
            this.$router.push('/chinese/select_task/select_test/' + this.sid + '/' + this.type + '?tarType=1');
        }
    },
    created () {

        let chinese_send_ok = localStorage.getItem('chinese_send_ok');
        if (chinese_send_ok == 1) {
            this.$router.go(-1);
            return false;
        }
        this.title = this.type == 0 ? '同步习题' : '单元复习';
        this.$http.post(API_URL_TASK_API + '/chinese/make/exercises_paper', {
            ch_id: this.cid.join(','),
            type: this.type,
            'sid': this.sid
        }).then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.list = res.data;
                this.list.forEach(l => {
                    l.question_data.forEach(v => {
                        v.active = 1;
                    })
                });
                this.loading = true;
            }
        })
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";

.paper {
    padding-bottom: 96px / $ppr;
    min-height: 100vh;
    box-sizing: border-box;
    .header-wrap {
        .header {
            background: #5e89ef;
        }
        .left {
            width: 18px / $ppr;
            height: 34px / $ppr;
            background: url("./img/white_back.png") no-repeat;
            background-size: 100% 100%;
        }
    }
    .list {
        margin-bottom: 24px / $ppr;
        background: #fff;
        h3 {
            padding: 0 24px / $ppr;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 30px / $ppr;
            font-weight: bold;
            color: #333;
        }
        li {
            padding: 0 24px / $ppr;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 30px / $ppr;
            color: #555;
            border-top: 1px / $ppr solid #e8e8e8;
            position: relative;
            z-index: 1;
            .recom {
                width: 380px / $ppr;
                span {
                    margin-right: 10px / $ppr;
                    max-width: 260px / $ppr;
                    vertical-align: top;
                }
            }
            span {
                display: inline-block;
                @include ellipsis;
            }
            .preview {
                position: absolute;
                right: 32%;
                font-size: 30px / $ppr;
                color: #5e89ef;
                z-index: 2;
            }
            .right {
                float: right;
                .add,
                .remove {
                    display: inline-block;
                    margin-left: 40px / $ppr;
                    width: 122px / $ppr;
                    height: 48px / $ppr;
                    line-height: 48px / $ppr;
                    font-size: 24px / $ppr;
                    text-align: center;
                    border-radius: 48px / $ppr;
                    box-sizing: border-box;
                    &.add {
                        border: 1px / $ppr solid #5e89ef;
                        color: #5e89ef;
                    }
                    &.remove {
                        border: 1px / $ppr solid #ff6600;
                        color: #ff6600;
                    }
                }
            }
        }
        div.norecommend {
            padding-left: 24px / $ppr;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            font-size: 30px / $ppr;
            color: #555;
            border-top: 1px / $ppr solid #e8e8e8;
        }
    }
    .self {
        padding: 0 24px / $ppr;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 30px / $ppr;
        color: #555;
        background: #fff;
        .optional {
            float: right;
            color: #5e89ef;
            i {
                display: inline-block;
                margin-left: 24px / $ppr;
                width: 14px / $ppr;
                height: 26px / $ppr;
                background: url("./img/enter.png") no-repeat;
                background-size: 100% 100%;
                vertical-align: middle;
            }
        }
    }
    .bottom_btn {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100vw;
        z-index: 5;
        a {
            display: inline-block;
            width: 100%;
            height: 96px / $ppr;
            line-height: 96px / $ppr;
            text-align: center;
            font-size: 36px / $ppr;
            color: #999999;
            background-color: $line;
            &.btn_a {
                color: #fff;
                background-color: #5e89ef;
            }
        }
    }
}
</style>
